exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".headerTotal-f0971{display:flex;flex-direction:column;align-items:center}.headerTotal-f0971 .values-4897f{margin:4px 0 12px}.headerTotal-f0971 .totalItem-1d477{font-size:20px}", ""]);

// Exports
exports.locals = {
	"headerTotal": "headerTotal-f0971",
	"values": "values-4897f",
	"totalItem": "totalItem-1d477"
};